import React from 'react';

interface BlinkingSvgProps {
  src1: string;
  src2: string;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
  color?: string;
  onClick?: () => void;
}

export const BlinkingSvg: React.FC<BlinkingSvgProps> = ({
  src1,
  src2,
  className = '',
  style,
  alt = '',
  color,
  onClick,
}) => {
  const blinkingClass = 'blinking-svg';
  const combinedClassName = `${blinkingClass} ${className}`.trim();

  // Pass URLs into @keyframes svgBlink via components.scss (var(--svg-url-*)).
  const combinedStyle: React.CSSProperties = {
    '--svg-url-1': `url(${src1})`,
    '--svg-url-2': `url(${src2})`,
    fill: `${color}`,
    ...style,
  } as React.CSSProperties;

  return (
    <>
      <img
        src={src1} // Fallback for accessibility/semantics
        alt={alt}
        className={combinedClassName}
        style={combinedStyle}
        onClick={onClick}
      />
    </>
  );
};
